import React from "react"

interface Order {
  _id: string
  productId?: {
    name: string
    description: string
    price: number
    currency: string
    imageUrl?: string
  }
  amount: number
  currency: string
  status: string
  createdAt: string
  paymentReference?: string
  deliveryAddress?: {
    street: string
    city: string
    state: string
    zipCode: string
    country: string
  }
  trackingNumber?: string
  itemName?: string
  itemType?: string
}

interface OrdersViewProps {
  orders: Order[]
  onClose: () => void
  onPayOrder?: (order: Order) => void
}

export function OrdersView({ orders, onClose, onPayOrder }: OrdersViewProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed': return '#10b981'
      case 'processing': return '#3b82f6'
      case 'shipped': return '#8b5cf6'
      case 'delivered': return '#059669'
      case 'pending': return '#f59e0b'
      case 'failed': return '#ef4444'
      case 'cancelled': return '#6b7280'
      default: return '#6b7280'
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h3 style={{ 
          fontSize: '18px', 
          fontWeight: '600', 
          margin: 0,
          color: '#1f2937'
        }}>
          My Orders
        </h3>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#6b7280',
            padding: '4px'
          }}
        >
          ×
        </button>
      </div>

      {orders.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          color: '#6b7280'
        }}>
          <p>No orders found</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {orders.map((order) => (
            <div
              key={order._id}
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                backgroundColor: '#ffffff'
              }}
            >
              <div style={{ display: 'flex', gap: '12px' }}>
                {order.productId && order.productId.imageUrl && (
                  <img
                    src={order.productId.imageUrl}
                    alt={order.productId.name}
                    style={{
                      width: '60px',
                      height: '60px',
                      objectFit: 'cover',
                      borderRadius: '6px'
                    }}
                  />
                )}
                <div style={{ flex: 1 }}>
                  <h4 style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    margin: '0 0 4px 0',
                    color: '#1f2937'
                  }}>
                    {order.productId ? order.productId.name : (order.itemName || 'Service Order')}
                  </h4>
                  <p style={{
                    fontSize: '14px',
                    color: '#6b7280',
                    margin: '0 0 8px 0'
                  }}>
                    {order.productId ? order.productId.description : 'Service booking order'}
                  </p>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <span style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#1f2937'
                    }}>
                      {order.currency} {order.amount}
                    </span>
                    <span style={{
                      fontSize: '12px',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      backgroundColor: `${getStatusColor(order.status)}20`,
                      color: getStatusColor(order.status),
                      fontWeight: '500',
                      textTransform: 'capitalize'
                    }}>
                      {order.status}
                    </span>
                  </div>
                  <p style={{
                    fontSize: '12px',
                    color: '#9ca3af',
                    margin: '8px 0 0 0'
                  }}>
                    {formatDate(order.createdAt)}
                  </p>
                  
                  {order.trackingNumber && (
                    <p style={{
                      fontSize: '12px',
                      color: '#3b82f6',
                      margin: '4px 0 0 0',
                      fontWeight: '500'
                    }}>
                      Tracking: {order.trackingNumber}
                    </p>
                  )}
                  
                  {order.deliveryAddress && (
                    <p style={{
                      fontSize: '12px',
                      color: '#6b7280',
                      margin: '4px 0 0 0'
                    }}>
                      {order.deliveryAddress.street}, {order.deliveryAddress.city}, {order.deliveryAddress.state} {order.deliveryAddress.zipCode}
                    </p>
                  )}
                  
                  {order.status === 'pending' && onPayOrder && (
                    <button
                      onClick={() => onPayOrder(order)}
                      style={{
                        marginTop: '8px',
                        padding: '6px 12px',
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: '500',
                        cursor: 'pointer'
                      }}
                    >
                      Pay Now
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}